'use client';

import { ArrowDropDown } from '@mui/icons-material';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import SaveIcon from '@mui/icons-material/Save';
import SaveAsIcon from '@mui/icons-material/SaveAs';
import { Button, ListItemIcon, ListItemText, Menu, MenuItem } from '@mui/material';
import { useState } from 'react';

export function ProjectSaveButton(props: {
  /**
   * 업데이트 버튼 표시 여부, 기본값 false
   */
  visibleUpdateBtn?: boolean;

  /**
   * 서버에 저장
   * 업데이트 저장
   */
  onClickSaveUpdateBtn: React.MouseEventHandler;

  /**
   * 다른이름으로 서버에 저장
   * 무조건 신규 저장
   */
  onClickSaveNewBtn: React.MouseEventHandler;

  /**
   * 파일로 저장
   */
  onClickDownloadBtn: React.MouseEventHandler;
}) {
  const {
    visibleUpdateBtn = false,
    onClickSaveNewBtn,
    onClickSaveUpdateBtn,
    onClickDownloadBtn,
  } = props;
  const [menuAnchorEl, setMenuAnchorEl] = useState<null | HTMLElement>(null);
  const menuOpened = Boolean(menuAnchorEl);

  const handleClose = () => {
    setMenuAnchorEl(null);
  };

  return (
    <>
      <Button
        color="inherit"
        onClick={(e) => {
          setMenuAnchorEl(e.target as HTMLElement);
        }}
        endIcon={<ArrowDropDown />}
      >
        저장
      </Button>
      <Menu anchorEl={menuAnchorEl} open={menuOpened} onClose={handleClose}>
        {visibleUpdateBtn && (
          <MenuItem
            onClick={(e) => {
              handleClose();
              setTimeout(() => {
                onClickSaveUpdateBtn(e);
              }, 50);
            }}
          >
            <ListItemIcon>
              <SaveIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText>저장</ListItemText>
          </MenuItem>
        )}

        <MenuItem
          onClick={(e) => {
            handleClose();
            setTimeout(() => {
              onClickSaveNewBtn(e);
            }, 50);
          }}
        >
          <ListItemIcon>
            <SaveAsIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>새 프로젝트 저장</ListItemText>
        </MenuItem>
        <MenuItem
          onClick={(e) => {
            handleClose();
            setTimeout(() => {
              onClickDownloadBtn(e);
            }, 50);
          }}
        >
          <ListItemIcon>
            <FileDownloadIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>파일로 저장</ListItemText>
        </MenuItem>
      </Menu>
    </>
  );
}
